import { useLang } from "../i18n";

export const Marquee = () => {
  const { t } = useLang();
  const items = t.marquee;
  return (
    <div
      aria-hidden="true"
      className="border-y border-sand bg-surface overflow-hidden py-5 select-none"
    >
      <div className="flex w-max animate-marquee gap-16 pr-16">
        {[...items, ...items].map((item, i) => (
          <span key={i} className="flex items-center gap-16 whitespace-nowrap">
            <span className="font-serif italic text-lg md:text-xl text-sage/80">{item}</span>
            <span className="text-terra text-sm" aria-hidden="true">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
